module.exports = {
  PREDES_TRANSACTIONS_OBJECT_REQUEST: 'PREDES_TRANSACTIONS_OBJECT_REQUEST',
  PREDES_TRANSACTIONS_OBJECT_SUCCESS: 'PREDES_TRANSACTIONS_OBJECT_SUCCESS',
  PREDES_TRANSACTIONS_OBJECT_FAILURE: 'PREDES_TRANSACTIONS_OBJECT_FAILURE',
};
